import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';

import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgIconModule } from '@app/src/app/icon';
import { MgPipesModule } from '@app/src/app/pipes';

import { GenericButtonModule } from '@shared/components/button';
import { FormModule } from '@shared/components/form';
import { OverlayModule } from '@shared/components/modal-overlay';
import { ArrayPipesModule } from '@shared/pipes';

import { TextModule } from '../text/text.module';
import { RedeemPointsModalComponent } from './redeem-points-modal.component';
import { RedeemPointsModalService } from './services';

@NgModule({
  imports: [
    // Minga dependencies
    MgEmptyStateModule,
    GenericButtonModule,
    MgPipesModule,
    ArrayPipesModule,
    MgIconModule,
    MgFormFieldModule,
    OverlayModule,
    FormModule,
    TextModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    MatTableModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
  ],
  exports: [RedeemPointsModalComponent],
  declarations: [RedeemPointsModalComponent],
  providers: [RedeemPointsModalService],
})
export class RedeemPointsModalModule {}
